<template>
    <div class="mainCopy">

        <div class="mainCopyText" v-html="mainCopy"></div>
        <div class="kingaku" v-text="shusiText"></div>

    </div>
</template>

<script>
import CalcUtil from "@/store/calcUtil.js"
export default {
    name: "MainCopy.vue",
    props: [
        'shushi',
        'isShinchiku',
    ],
    data() {
        return {
            shinchiku: {
                plus:
                    // '  今すぐ持家を購入した場合の<br>' +
                    '        90歳時点の貯蓄額（❶ 収入累計額 − ❷ 支出総額）は<br>' +
                    '        <span class="mainCopyShusi">_SHUSHI_のプラス</span>と試算されました。',
                minus:
                    // '  今すぐ持家を購入した場合の<br>' +
                    '        90歳時点の収支（❶ 収入累計額 − ❷ 支出総額）は<br>' +
                    '        <span class="mainCopyShusi">_SHUSHI_のマイナス</span>と試算されました。',
            },
        }
    },
    computed: {
        shusiText() {
            let shusiText = this.shushi*1;

            if (!isNaN(shusiText)) {
                shusiText = CalcUtil.manYenToOkuYen(shusiText)+'万円';
            }
            else{
                shusiText = 0;
            }

            return shusiText;

        },
        mainCopy(){
            let plan = 'shinchiku';
            let sign = 'plus';

            if (this.shushi < 0) {
                sign = 'minus';
            }

            return this[plan][sign].replace('_SHUSHI_', this.shusiText);
        },
    }
}
</script>

<style lang="scss" >

.mainCopy {
    display: flex;
    align-items: stretch;

    position: relative;
    padding-top: 40px;

    border-left: 1px solid #000;
    border-right: 1px solid #000;

    font-size: 16px;
    //font-weight: bold;

    .shuushiTitle {
        position: absolute;
        top: 0;
        right: 0;
        text-align: center;
        line-height: 20px;
        font-size: 18px;
        font-weight: bold;

        width: 180px;

        .sub-text {
            font-size: 12px;
        }
    }

    .mainCopyText {
        flex-grow: 1;

        border: 2px solid #e3676b;
        background-color: #F6E1E2;

        padding: 5px 10px;
    }

    .kingaku {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 180px;

        padding-right: 10px;

        background-color: #e3676b;

        color: #fff;
        font-size: 23px;
        font-weight: bold;
    }

}


@media screen and (max-width: 500px) {

    .mainCopy {

        .mainCopyShusi {
            font-size: 20px;
        }

        .shuushiTitle {
            display: none !important;
        }

        .kingaku {
            display: none !important;
        }

    }

}



</style>